import { activateOrgTrialEndpoint, httpRequestWithToken } from '../../utils/http';

export const triggerOrgTrial = async () => {
  return httpRequestWithToken({
    url: activateOrgTrialEndpoint,
    method: 'POST',
    payload: { planType: 'Pro' },
  });
};
